import type { Step, UpdateUserOnboardingStep, UserOnboardingStep } from '@cobliteam/api-lib';

import type { OnboardingStep } from '../store/slices/onboardingSteps';

enum StepStatus {
  INITIAL = 'INITIAL',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  BLOCKED = 'BLOCKED',
  SKIPPED = 'SKIPPED',
}

const getStepStatus = (step?: UserOnboardingStep, dependentStep?: UserOnboardingStep): StepStatus => {
  if (dependentStep && dependentStep.endedAt == null) return StepStatus.BLOCKED;

  if (step?.skippedAt != null) return StepStatus.SKIPPED;

  if (step?.startedAt != null && step?.endedAt != null) return StepStatus.COMPLETED;

  if (step?.startedAt != null && step?.endedAt == null) return StepStatus.IN_PROGRESS;

  return StepStatus.INITIAL;
};

const findStep = (step: Step, steps: UserOnboardingStep[]): OnboardingStep | undefined => {
  const maybeStep = steps.find((onboardingStep) => onboardingStep.stepInfo.step === step);
  const maybeDependentStep = steps.find((onboardingStep) => {
    return maybeStep ? onboardingStep.stepInfo.step === maybeStep?.stepInfo.dependsOn : undefined;
  });

  if (maybeStep) {
    return {
      stepName: maybeStep.stepInfo.step,
      startedAt: maybeStep.startedAt,
      endedAt: maybeStep.endedAt,
      skippedAt: maybeStep.skippedAt,
      stepStatus: getStepStatus(maybeStep, maybeDependentStep),
      dependsOn: maybeDependentStep?.stepInfo.step,
      dependentStepStartedAt: maybeDependentStep?.startedAt,
      dependentStepEndedAt: maybeDependentStep?.endedAt,
    };
  }

  return undefined;
};

const toUpdateUserOnboardingStep = (userOnboardingStep: UserOnboardingStep): UpdateUserOnboardingStep => {
  return {
    step: userOnboardingStep.stepInfo.step,
    started_at: userOnboardingStep.startedAt,
    ended_at: userOnboardingStep.endedAt,
    skipped_at: userOnboardingStep.skippedAt,
  };
};

const onboardingStepToUpdateUserOnboardingStep = (userOnboardingStep: OnboardingStep): UpdateUserOnboardingStep => {
  return {
    step: userOnboardingStep.stepName,
    started_at: userOnboardingStep.startedAt,
    ended_at: userOnboardingStep.endedAt,
    skipped_at: userOnboardingStep.skippedAt,
  };
};

export { StepStatus, getStepStatus, findStep, toUpdateUserOnboardingStep, onboardingStepToUpdateUserOnboardingStep };
